import { useEffect } from "react"
import { ErrorComponentProps } from "@tanstack/react-router"

import { isTosException } from "@src/api/user"
import { useAppStore } from "@src/state"
import { Error } from "@src/components/atoms/Error"

export const DefaultErrorComponent = ({ error }: ErrorComponentProps) => {
  const isTos = isTosException(error)

  useEffect(() => {
    if (isTos) {
      useAppStore.setState({ mustAcceptTos: true })
    }
  }, [isTos])

  if (isTos) {
    // AuthWrapper in _auth.tsx renders AcceptTermsDialog when mustAcceptTos is true.
    // Return null here to suppress the default error UI in the outlet.
    return null
  }

  return <Error code={0} />
}
